<script lang="ts">
/*
Smart Input box- 

Should populate a list below of of all the previous inputs, and allow them to select any, but also allow typing in (and sorting what is in the input box based on what they typed so far)

requires: fuzzysort: https://github.com/farzher/fuzzysort
to be able to sort stuff when typing, to see last stuff that got typed in

*/
import { defineComponent } from 'vue'
import ButtonVue from './Button.vue';
import StaticVars from '@/ts/StaticVars';
import type { ItemTypeDB } from '@/ts/DexieDB';

export class ObjectIn
{
    id!:string;
    name!:string;
    date_updated!:Date;
    constructor()
    {
        return this;
    }
    Init(id:string, name:string, date_updated:Date)
    {
        this.id=id;
        this.name=name;
        this.date_updated=date_updated;
        return this;
    }
    Name(name:string)
    {
        this.id="-1";
        this.name=name;
        return this;
    }
}

export default defineComponent(
{
    components: { ButtonVue },
    props: {
        default_value: { type: String },
        placeholder: { type: String },
        previous_entries_in: { type: Array<ObjectIn>, default:[] }, //entries of strings
        TextChanged: { type: Function, default: (new_text:String) => {console.log("InputTextSmart: TextChangeDefaultFunctionCalled- override to get text changed events"); } },
        Submit: { type: Function, default: () => { console.log("InputTextSmart Submit clicked");} },// function for when the submit button is clicked, or the enter button is clicked
        show_submit_btn:{type:Boolean, default:true},

        key:<any>Object,

        //For if we want something else to happen when a previous entry is clicked. Main case is for telling the parent which one was clicked, then clearing it out, so the parent can populate it in the list, and clear out this entry to be used again 
        PrevEntryClickedCallBack: { type: Function, default: null },
        entry:{ type: Object, default: null} 

        
        // sort_by_name:{type:Boolean, default:true}

    },
    async mounted() 
    {
        // console.log("input text smart mounted! previous entires: ", this.previous_entries);
        // console.log("input text smart mounted! placeholder ", this.placeholder);


        //only focus is no default value
        if(!this.default_value&&!this.entry) //and if not being populated from the other field
        {
            (this.$refs.text as HTMLInputElement).focus();
            console.log("inputtext smart focusing on: ",this.$refs.text )
        }

        // console.log("this.previous_entries_in: ",this.previous_entries_in);

        if(this.default_value)
        {
            // (this.$refs.text as HTMLInputElement).value = this.default_value;
            this.SetText(this.default_value);
            this.value=this.default_value;
            // (this.$refs.text as HTMLInputElement).value = this.value;
            this.SetText(this.value);

            //have a default item_selected- in case we need to check what it is/ see that nothing has changed
            this.item_selected = new ObjectIn().Name(this.value);
        }
        
        // this.$nextTick(() => 
        //     {
        //         this.ResizeBoxVerticalToFitText(this.$refs.text);
        //     });
        
        
        this.PreviousEntriesIn();

        if(this.entry)
        {
            console.log("INPUT entry ==", this.entry);
            this.PrevEntryClickedForced(this.entry);
        }

        
        // console.log("MOUNTED: default value: ", this.default_value, "this prev previous_entries_in: ", this.previous_entries_in);
        //first sort by date
    },
    updated()
    {
        // console.log("input text smart, updated!", this.$refs.text, (this.$refs.text as any).value);
        this.ResizeBoxVerticalAndHorizontalToFitText({target:this.$refs.text});
    },
    
    data() {
        return {
            text: "",
            // value: "",
            previous_entries:new Array<any>() ,
            render_self:true,
            value:"",
            item_selected:new ObjectIn(), //for if a previous item clicked- or if a new one with -1
            changed:false, //if changed- can show a submit button
            key_to_force_update:0,//to try to get vue to update things- when changing previous_entries, vue doesn't update
        };
    },
    watch : {
        previous_entries_in:function(previous_entries_in) {
            // console.log("watch previous_entries_in start called", previous_entries_in, "this text: ", this.value);
            this.PreviousEntriesIn();
            // console.log("watch previous_entries_in start finsihed", previous_entries_in, "this text: ", this.value);
                //   this.date_s = this.ChangeDateToRequiredStringFormat(date_in);
               },


        previous_entries:function(previous_entries)
        {
            //this is probably getting updated finally on the next frame with "forceupdateview"
            //so might have to watch this to then sort/ remove duplicates- since no other consistant way to do it, since vue doesn't always update

            // console.log("watch previous_entries start called", previous_entries, "this text: ", this.value, this.previous_entries_in);
            // console.log(JSON.stringify(previous_entries));
            this.key_to_force_update++;
            // this.CheckIfTextEqualsPrevEntry();

        }
        
    },
    methods: {

        async PreviousEntriesIn()
        {
            // console.log("InputTextSmart prev entries in", this.value);

            if(this.previous_entries_in.length>0)
            {
                // console.log("InputTextSmart prev entries: ", this.value, this.previous_entries_in.length);
                this.previous_entries = [...this.previous_entries_in];
                
                // console.log("might be where it's changing- when I force it on the next frame");
                // StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");
                // console.log("InputTextSmart prev entries2: ", this.value, this.previous_entries.length);

                if(this.value=="")
                    this.SortByLastUpdated();
                else
                    this.SortByTextInputted();
                
            }
            else
            this.previous_entries = [];
            // console.log("PreviousEntriesIn1, item selected: ",this.value,  this.item_selected, "length: ", this.previous_entries.length);
            //also select one if the default value == a prev entry
            this.previous_entries_in.map((entry)=>{
                // console.log("PreviousEntriesIn157, entry.name", entry.name, "this.value", this.value);
                if(entry.name ==this.value)
                {
                    this.item_selected = entry;
                    // console.log("PreviousEntriesIn157, entry found!, prev entries: ", this.previous_entries);
                }
                return entry;
            });
            // console.log("PreviousEntriesIn2, item selected2: ",this.value,  this.item_selected);
        },
        focus() {
            (this.$refs.text as HTMLInputElement).focus();
        },
        GetButtonText(entry:any)
        {
            // console.log("date_updated: ",entry.date_updated);
            return entry.name;
            // return entry.name +"-"+  entry.date_updated.toLocaleDateString() +" -- "+entry.date_updated.toLocaleTimeString();
        },

        async SortByLastUpdated()
        {
            //check if the input in is equal to one of the previous inputs, and don't show anything if it is
            
            if(this.CheckIfTextEqualsPrevEntry())
                return;

            // console.log("sort by last updated called", this.value);

            //https://stackoverflow.com/questions/10123953/how-to-sort-an-object-array-by-date-property
            // console.log("this.previous_entries1: ", this.previous_entries);
            let new_array = [...this.previous_entries_in];
            new_array.sort(function(a,b)
            {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return b.date_updated.getTime() - a.date_updated.getTime();
            });
            // new_arr2.push({name:"test", date_updated:new Date()});
            this.previous_entries=new_array;
            
            // console.log("this.previous_entries: ", this.previous_entries);
            // StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");
            //this doesn't even work
            // this.$forceUpdate();
            //this actually finally works
            // this.previous_entries = [];
            // this.$nextTick(() => {
            //     this.previous_entries = [...new_arr2];
            // });
            // console.log("sort by last updated2 finished", this.value);
            
        },

        //check if text entry is the same as a prev entry, sets it to that, and clears out the array
        CheckIfTextEqualsPrevEntry()
        {
            // let text = ((this.$refs.text as HTMLInputElement).value as string).trim();
            let text = (this.GetText() as string).trim();
            // console.log("CheckIfTextEqualsPrevEntry", text);

            if(text.length==0)
                return false;

            let input_equals_prev_entry=false;
            for (let i = 0; i < this.previous_entries_in.length; i++)
            {
                const prev_entry = this.previous_entries_in[i];
                if(text==prev_entry.name)
                {
                    input_equals_prev_entry=true;
                    this.item_selected = prev_entry;
                    break;
                }                
            }


            if(input_equals_prev_entry)
            {
                let new_arr=new Array();
                this.previous_entries=new_arr;
                // StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");

                // console.log("text == prev text! clearing out array!", text);
            }
            // else
            //     console.log("text !== prev text! not clearing out array!", text);

            // console.log("CheckIfTextEqualsPrevEntry2", text);
            
            return input_equals_prev_entry;
        },
        SortByTextInputted()
        {
            // let text = ((this.$refs.text as HTMLInputElement).value as string).trim();
            let text = (this.GetText() as string).trim();

            // console.log("SortByTextInputted", text);

            if(text.length==0)
            {
                this.SortByLastUpdated();
                return;
            }

            //check if the input in is equal to one of the previous inputs, and don't show anything if it is
            if(this.CheckIfTextEqualsPrevEntry())
                return;
            
            
            let using_fuzzy_search=true;
            if(using_fuzzy_search)
            {
                // console.log("using fuzzy search");
                //@ts-ignore - because using it in script folder, instead of npm- because it got blocked on the front end from loading, for some reason...
                const results = fuzzysort.go(text, this.previous_entries_in, {key:'name'});
                // console.log("fuzzy search results: ", results);
                let new_arr=[];
                for (let i = 0; i < results.length; i++) 
                {                    
                    const element = results[i].obj;
                    // console.log("element: ", element);
                    new_arr.push(element);
                }
                
                this.previous_entries=[...new_arr];
                // console.log("using fuzzy search2, array: ", this.previous_entries, "new_arr", new_arr);
            }
            else
            {
                //should grab th etext entered so far, and then try to organize it based on how it matches it
                //lets create an array of the values for each one
                let self=this;
                // console.log("SortByTextInputted1: ", this.previous_entries);
                let new_arr = [...this.previous_entries_in];
                new_arr.sort(function(a,b)
                {
                    let b_val = self.LevenshteinDistance(b.name, text);
                    let a_val = self.LevenshteinDistance(a.name, text);
                    // console.log("SortByTextInputted: text: ", text, "b: ", b.name, "b value: ", b_val, "; a: ", a.name, "a_val: ", a_val)
                    return a_val-b_val;
                });
                this.previous_entries=[...new_arr];
                // console.log("SortByTextInputted2: ", this.previous_entries);
            }
            // StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");

            // console.log("SortByTextInputted2", text);
        },
        //for comparing two strings, to see how close they are to each other- will giv e avalue back based on how many changes it takes to change one to the next:
        //so the higher value, the longer it will take to change it to the other one.
        //function from: https://www.tutorialspoint.com/levenshtein-distance-in-javascript
        //what it actually is: https://en.wikipedia.org/wiki/Levenshtein_distance
        //stack overflow on making it faster: https://stackoverflow.com/questions/18516942/fastest-general-purpose-levenshtein-javascript-implementation


        LevenshteinDistance(str1 = '', str2 = ''):number
        {
            const track = Array(str2.length + 1).fill(null).map(() =>
            Array(str1.length + 1).fill(null));
            for (let i = 0; i <= str1.length; i += 1) {
                track[0][i] = i;
            }
            for (let j = 0; j <= str2.length; j += 1) {
                track[j][0] = j;
            }
            for (let j = 1; j <= str2.length; j += 1) {
                for (let i = 1; i <= str1.length; i += 1) {
                    const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
                    track[j][i] = Math.min(
                        track[j][i - 1] + 1, // deletion
                        track[j - 1][i] + 1, // insertion
                        track[j - 1][i - 1] + indicator, // substitution
                    );
                }
            }
            return track[str2.length][str1.length];
        },
        PrevEntryClicked(e:any)
        {
            e = {...e};
            console.log("PrevEntryClicked: ", e.name, e.id, e);

            //if there is a callback/ it doesn't work in normal mode of just changing out the text with the previous one clicked, btu instead if going to use the clicked value to pass back tot he parent (to make a new button input with what was clicked)
            if(this.PrevEntryClickedCallBack)
            {
                console.log("PrevEntryClicked: calling custom callback ");
                this.PrevEntryClickedCallBack(e)

                //clear out text box:
                if(this.GetText())
                {
                    console.log("PrevEntryClicked: clearing input box");
                    this.value="";
                    
                    this.SetText("");
                    // (this.$refs.text as HTMLInputElement).value = "";
                    this.TextChanged("");
                    this.focus();

                    //should also repopulate the previousentries, to show it again
                    this.PreviousEntriesIn();
                }
                
            }
            else
            {
                this.PrevEntryClickedForced(e);
            }
            
        },

        //helper functions to get and set the text from the textfield- since we were using textarea before, now div with contenteditable=true
        GetText()
        {
            //for using textarea:
            // return (this.$refs.text as HTMLInputElement).value;

            //for using div contenteditable
            // return ((this.$refs.text as HTMLInputElement).textContent||"").trim();
			return ((this.$refs.text as HTMLDivElement).innerText||"").trim();
        },
        SetText(text:string)
        {
            //for using textarea:
            // (this.$refs.text as HTMLInputElement).value = text;
			
			//2026-06-26 - changing, since it's a div, not an html input anymore, so getting the wrong value
            // (this.$refs.text as HTMLInputElement).textContent = text;
			(this.$refs.text as HTMLDivElement).innerText = text;
        },

        //if we want to change it out like normal- so when a new input gets created, but want it to behave like an entry was just clicked
        PrevEntryClickedForced(e:any)
        {
            this.value=e.name;
            this.item_selected=e;
            // (this.$refs.text as HTMLInputElement).value = e.name;
            this.SetText(e.name);
            this.TextChanged(e.name);
            

            //should also hide the list of previous entries
            this.previous_entries = [];
        },
        TextChangedInternal(e:any)
        {
			//2026-06-26 - changing, since it's a div, not an html input anymore, so getting the wrong value
            // this.value = (e.target as HTMLInputElement).value;
			this.value = (e.target as HTMLDivElement).innerText;
            this.ResizeBoxVerticalAndHorizontalToFitText(e);
			// console.log("TextChangedInternal, ", this.value);

            this.item_selected = new ObjectIn().Name(this.value);
            this.changed=true;
            this.TextChanged(this.value); 
            this.SortByTextInputted();
            // console.log("TextChangedInternal, ", this.item_selected);
			
        },
        ResizeBoxVerticalToFitText(e:any)
        {
            console.log("resizing box to fit text");
            let target = (e.target as HTMLInputElement);
            target.style.height = 'auto';
 
            target.style.height = (target.scrollHeight) + 'px';
        },
        ResizeBoxVerticalAndHorizontalToFitText(e:any)
        {
            return;
        },
        /* ResizeBoxVerticalAndHorizontalToFitText(e:any)
        {
            console.log("resizing box in both directions to fit text");
            let textarea = (e.target as HTMLInputElement);

            textarea.style.width = 'auto'; // Reset width
            textarea.style.height = 'auto'; // Reset height
            
            // Create a hidden clone to measure width
            const clone = document.createElement('div');
            clone.style.position = 'absolute';
            clone.style.visibility = 'hidden';
            clone.style.whiteSpace = 'pre-wrap'; // Wraps text as textarea does
            clone.style.wordWrap = 'break-word';
            clone.style.padding = getComputedStyle(textarea).padding; // Match padding
            clone.style.font = getComputedStyle(textarea).font; // Match font
            clone.style.width = 'auto';
            clone.style.maxWidth = textarea.style.maxWidth; // Keep within max width
            clone.textContent = textarea.value || textarea.placeholder || ' ';
            
            document.body.appendChild(clone);
            
            // Set width based on text size, but not exceeding max-width
            textarea.style.width = Math.min(clone.scrollWidth, parseInt(textarea.style.maxWidth)) + 'px';

            // Set height based on content
            textarea.style.height = textarea.scrollHeight + 'px';
            // textarea.style.height = getComputedStyle(clone).height;
            
            document.body.removeChild(clone);
        }, */
        SubmitInternal()
        {
            // console.log("submit hit!");
            this.Submit();
            this.changed=false;
        },
        CollapsePrevEntries()
        {
            //should also hide the list of previous entries
            this.previous_entries = [];
        },
        
        //for when the list changes, and need to clear the input field
        // DataUpdatedExternally(clear_input:boolean=true)
        // {
        //     if(clear_input)
        //     {
        //         (this.$refs.text as HTMLInputElement).value ="";
        //     }
        //     this.ForceReRender();
        // },
        // ForceReRender()
        // {
        //      // Remove my-component from the DOM
        //     this.render_self = false;
        //     console.log("ForceReRender run!!");

        //     this.$nextTick(() => 
        //     {
        //         // Add the component back in
        //         this.render_self = true;
        //     });
        // }


    },
    
});
</script>


<template>
    <div class="container" v-if="render_self">
        
        <!-- <p>Hello</p> -->
        <!-- <input class="input_txt" type="text" :placeholder="placeholder"  -->
        <!-- <textarea class="input_txt" type="text" :placeholder="placeholder"  -->
        <div contenteditable="true" class="input_txt" type="text" :placeholder="placeholder" 
        @input="(e)=>{TextChangedInternal(e)}" 
        
        @keyup.enter="()=>{/*SubmitInternal()*/}"
        ref="text"/>
        <!-- <p>Some text</p> -->
        <ButtonVue class="btn" text="" type="yes" :callback="SubmitInternal" v-if="changed&&show_submit_btn"/>

        <div class="container_inner" style="position: relative;" v-if="previous_entries.length>0"  :key="key_to_force_update">
            <div class="btn_container">
                <ButtonVue class="btn" v-for="entry in previous_entries" :text="GetButtonText(entry)" color_bg="var(--accent-color2)" :callback="(e:any)=>{PrevEntryClicked(e)}" :extra_info="entry"
                padding="5px 15px"
                fontsize="18px"
                fontweight="regular"
            
                />
            </div>
            <span class="c"></span>
        </div>
        
        <!-- <p v-for="entry in previous_entries">{{ entry }}</p> -->
    
    </div>
</template>

<style scoped>
.container
{
    /* display:flex;
    flex-direction: column; */
    /* display: inline-block; */
    max-width:100%;
    min-height:1em;
}

.input_txt, .btn
{
    /* height:.5in;
    padding:2%; */
    
    /* border:1px solid var(--grey5); */
    
    font-size:20px;
    transition: all .15s;
    line-height: 1.25em;
    
}
.input_txt
{
    /* background-color: #DDD;
    color:#333; */

    /*Stuff to allow the text area to resize dynamically using javascript  */
    resize: none; /* Prevent manual resizing */
    overflow: hidden; /* Hide scrollbars */
    min-width: 50px; /* Set a minimum width */
    max-width: 99%; /* Prevent it from exceeding the page width */
    display: block; /* Ensure it respects the parent's width */
    box-sizing: border-box; /* Include padding in width calculation */
    min-height: 1.5em; /* Minimum height */

    word-wrap: break-word;
    white-space: pre-wrap;
    height:auto;
    border: 1px solid var(--accent-color1);
    padding:10px 10px;

    background:var(--grey2);
    color:var(--greyD);
}
.input_txt:focus
{
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(var(--color1), 0.6);
}
.container_inner
{
    height:33vh;
    /* min-height:200px; */
    
}
.btn_container
{
    /* padding-top:10px; */
    display:flex;
    /* flex-direction: column; */
    flex-direction: row;
    /* white-space: nowrap; */
    flex-wrap: wrap;
    /* overflow-x: hidden; */
    overflow-y: scroll;
    max-height: 100%;
    
    
    
    /* max-height: 33vh; */
    
    /* gap:10px; */
    /* padding:5px; */
    /* margin-right:20px; */
    /* padding-right:15px; */
    border: 1px solid var(--grey5);
    /* background-color: var(--grey1); */
    position: relative;
    padding:5px;
    padding-top:10px;
    gap:0 5px;
}
.c
{
    --color:var(--color-background);
    /* --color:rgba(255,0,0,1); */
    content: "";
    background: linear-gradient(var(--color), 3%, rgba(0,0,0,0), 20%, rgba(0,0,0,0), 97%, var(--color));
    width:100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    pointer-events: none;
}
.btn
{
    cursor: pointer;
    transition: all .15s;
    height:auto;
    margin:0;
    margin-bottom:4px;
    margin-top:4px;
    
}
/* .btn:hover
{
    transform: scale(1.0);
} */
@media only screen and (max-device-width: 460px)
{
    .input_txt, .btn
    {
        /* font-size:20px; */
    }
}

/*
For having a placeholder on a contenteditable div:
https://stackoverflow.com/questions/20726174/placeholder-for-contenteditable-div
(4th answer) 
 */
[contenteditable=true]:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  display: block; /* For Firefox */
}

</style>